import { DEFAULT_METADATA_IDS } from '~/store2/layers';
import { PERMITTING_VISIBLE_UTILITY_LAYER_IDS } from './permittingVisibleLayerIds';

export { PERMITTING_VISIBLE_UTILITY_LAYER_IDS };

const permittingLayerIdSet = new Set<string>(PERMITTING_VISIBLE_UTILITY_LAYER_IDS);

/** Metadata label fields for identify/labels, limited to permitting utility layers. */
export const PERMITTING_DEFAULT_METADATA_FIELD_IDS = DEFAULT_METADATA_IDS.filter((id) =>
  permittingLayerIdSet.has(id.split('.')[0] ?? ''),
);
